import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { completeCognitoLogin } from '../cognito';

export function AuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    void (async () => {
      try {
        const returnTo = await completeCognitoLogin(params);
        if (!active) return;
        navigate(returnTo || '/', { replace: true });
      } catch (caught) {
        if (!active) return;
        setError(caught instanceof Error ? caught.message : 'PackProof could not complete sign-in.');
      }
    })();
    return () => { active = false; };
  }, [navigate, params]);

  return (
    <main className="sign-in card">
      <p className="eyebrow brand"><img src="/brand/packproof-icon.png" alt="" width="28" height="28" />PackProof</p>
      <h1>{error ? 'Sign-in did not finish' : 'Completing sign-in'}</h1>
      {error ? <p className="error">{error}</p> : <p className="lede">Binding this browser to your PackProof account.</p>}
    </main>
  );
}
